import { createContext, useContext, type ReactNode } from 'react';

/** Сериализуемое описание; содержимое панели собирает владелец образца или сервиса. */
export interface RightPanelItem {
  id: string;
  title: string;
  path: string;
  eyebrow?: string;
}

export interface RightPanelConfig {
  /** Отдельный ключ: панели образца не меняют настройки настоящего рабочего места. */
  storageKey: string;
  render: (item: RightPanelItem) => ReactNode;
  /** Необязательно: заголовок из актуальных данных после правки на месте. */
  title?: (item: RightPanelItem) => string;
  /** Компактные значки действий в шапке; false по умолчанию. */
  compactHeader?: boolean;
}

interface RightPanelApi {
  item: RightPanelItem | null;
  open: (item: RightPanelItem, trigger?: HTMLElement) => void;
  close: () => void;
}

export const RightPanelContext = createContext<RightPanelApi | null>(null);

export function useRightPanel(): RightPanelApi {
  const api = useContext(RightPanelContext);
  if (!api) throw new Error('useRightPanel: включи rightPanel у WorkspaceCanvas');
  return api;
}
